import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';
import {
	getAllVisibleClients,
	thisFunction,
} from '../../redux/clients/actions';
import { GetClientDocumentData } from './getClientDocumentData.api';
import getCoBrokersSalesAgent from './getCoBrokerSalesAgent.api';
import * as DOCUMENT_NAMES from '../../constants/documentNames';

export async function GetAllClientsForCoBroker(callback) {
	var salesAgentId;
	var currentUserId = firebase.auth().currentUser.uid;

	await getCoBrokersSalesAgent().then(
		(returned) => (salesAgentId = returned)
	);
	await firebase
		.database()
		.ref('kavtek_clients/' + PROJECT_CODE.projectCode + '/salesAgents')
		.orderByChild('createrID')
		.equalTo(salesAgentId)
		.limitToFirst(1)
		.on('value', async (snapshot) => {
			var allVisibleClients = [];
			var currentClientList = [];
			var nonVisibleClients = [];
			var thisSalesAgentPointer;
			var snapData = snapshot.val();

			var allKeys = (await snapData) && Object.keys(snapData);

			if (allKeys) {
				thisSalesAgentPointer = allKeys[0];

				var snapClients = snapData[thisSalesAgentPointer].myClients;
			}

			if (snapClients) {
				var snapClientsKeys = Object.keys(snapClients);

				for (var i = 0; i < snapClientsKeys.length; i++) {
					var aClient = snapClients[snapClientsKeys[i]];

					var apsSignatures;
					var condoDocsSignatures;

					var lastSignatureActivity;

					//start getting the status of the document
					//check for document information?
					if (aClient.documentInformation?.signatureRequests) {
						//get the signatureRequests keys;
						var signatureRequests =
							aClient.documentInformation.signatureRequests;

						var signatureRequestsKeys =
							Object.keys(signatureRequests);

						//get the signatureUpdates
						signatureRequestsKeys.forEach(
							(signatureRequestsKey) => {
								var signatureUpdates =
									signatureRequests[signatureRequestsKey];

								var stringSubjectAPS = DOCUMENT_NAMES.aps;
								var stringSubjectCondoDocs =
									DOCUMENT_NAMES.condo_docs;

								//check if it is APS
								if (
									signatureUpdates['subject'] ===
									stringSubjectAPS
								) {
									//check if there are signature updates
									if (signatureUpdates['signatureUpdates']) {
										//get the sig updates
										var signatureUpdates =
											signatureUpdates[
												'signatureUpdates'
											];

										//get the sig updates keys
										var signatureUpdatesKeys =
											Object.keys(signatureUpdates);

										//get the signatures
										apsSignatures =
											signatureUpdates[
												signatureUpdatesKeys[
													signatureUpdatesKeys.length -
														1
												]
											]['signature_request'][
												'signatures'
											];
										aClient['apsSignatures'] =
											apsSignatures;

										//get last signature activity
										lastSignatureActivity =
											signatureUpdates[
												signatureUpdatesKeys[
													signatureUpdatesKeys.length -
														1
												]
											]['event']['event_time'];

										aClient['lastSignatureActivity'] =
											lastSignatureActivity;

										var apsStatus = '';
										//getting the status of the APS
										if (apsSignatures) {
											var apsSignatureArray = [];
											var signatureKeys =
												Object.keys(apsSignatures);

											signatureKeys.forEach(
												(signatureKey) => {
													var status_code =
														apsSignatures[
															signatureKey
														]['status_code'];

													apsSignatureArray.push(
														status_code
													);
												}
											);

											if (
												apsSignatureArray.length === 3
											) {
												//3 signatures for one client
												//no second purchaser
												//check the status
												if (
													apsSignatureArray[0] ===
														'awaiting_signature' &&
													apsSignatureArray[1] ===
														'awaiting_signature' &&
													apsSignatureArray[2] ===
														'awaiting_signature'
												) {
													apsStatus =
														'Doc sent to home buyer';
													// } else if (
													// 	apsSignatureArray[0] === 'signed' &&
													// 	apsSignatureArray[1] === 'awaiting_signature' &&
													// 	apsSignatureArray[2] === 'awaiting_signature' )
													// {
													// 	apsStatus = 'Client signed';
												} else if (
													apsSignatureArray[0] ===
														'signed' &&
													apsSignatureArray[1] ===
														'awaiting_signature' &&
													apsSignatureArray[2] ===
														'awaiting_signature'
												) {
													apsStatus =
														'Admin to review';
												} else if (
													apsSignatureArray[0] ===
														'signed' &&
													apsSignatureArray[1] ===
														'signed' &&
													apsSignatureArray[2] ===
														'awaiting_signature'
												) {
													apsStatus =
														'Builder to sign';
												} else if (
													apsSignatureArray[
														apsSignatureArray.length -
															1
													] === 'signed'
												) {
													let currentTime =
														Math.floor(
															Date.now() / 1000
														);
													if (
														currentTime -
															parseInt(
																lastSignatureActivity
															) <
														864000
													) {
														apsStatus =
															'Cooling period';
													} else {
														apsStatus = 'Firm deal';
													}
												}
											} else if (
												apsSignatureArray.length === 4
											) {
												//gelnridge only has 4
												//have second purchaser
												if (
													apsSignatureArray[0] ===
														'awaiting_signature' &&
													apsSignatureArray[1] ===
														'awaiting_signature' &&
													apsSignatureArray[2] ===
														'awaiting_signature' &&
													apsSignatureArray[3] ===
														'awaiting_signature'
												) {
													apsStatus =
														'Doc sent to home buyer';
													// } else if (
													// 	apsSignatureArray[0] === 'signed' &&
													// 	apsSignatureArray[1] === 'awaiting_signature' &&
													// 	apsSignatureArray[2] === 'awaiting_signature' &&
													// 	apsSignatureArray[3] === 'awaiting_signature'
													// ) {
													// 	apsStatus = 'First client signed';
												} else if (
													apsSignatureArray[0] ===
														'signed' &&
													apsSignatureArray[1] ===
														'awaiting_signature' &&
													apsSignatureArray[2] ===
														'awaiting_signature' &&
													apsSignatureArray[3] ===
														'awaiting_signature'
												) {
													apsStatus =
														'Second client to sign';
													// } else if (
													// 	apsSignatureArray[0] === 'signed' &&
													// 	apsSignatureArray[1] === 'signed' &&
													// 	apsSignatureArray[2] === 'signed' &&
													// 	apsSignatureArray[3] === 'awaiting_signature'
													// ) {
													// 	apsStatus = 'Client signed';
												} else if (
													apsSignatureArray[0] ===
														'signed' &&
													apsSignatureArray[1] ===
														'signed' &&
													apsSignatureArray[2] ===
														'awaiting_signature' &&
													apsSignatureArray[3] ===
														'awaiting_signature'
												) {
													apsStatus =
														'Admin to review';
												} else if (
													apsSignatureArray[0] ===
														'signed' &&
													apsSignatureArray[1] ===
														'signed' &&
													apsSignatureArray[2] ===
														'signed' &&
													apsSignatureArray[3] ===
														'awaiting_signature'
												) {
													apsStatus =
														'Builder to sign';
												} else if (
													apsSignatureArray[
														apsSignatureArray.length -
															1
													] === 'signed'
												) {
													let currentTime =
														Math.floor(
															Date.now() / 1000
														);
													if (
														currentTime -
															parseInt(
																lastSignatureActivity
															) <
														864000
													) {
														apsStatus =
															'Cooling period';
													} else {
														apsStatus = 'Firm deal';
													}
												}
											}
										}
										aClient['apsStatus'] = apsStatus;
										console.log(
											'COBROKER APS STATUS ',
											apsStatus
										);
									}
								}

								//check if it is condo docs
								if (
									signatureUpdates['subject'] ===
									stringSubjectCondoDocs
								) {
									//check if there are signature updates
									if (signatureUpdates['signatureUpdates']) {
										//get the sig updates
										var signatureUpdates =
											signatureUpdates[
												'signatureUpdates'
											];

										//get the sig updates keys
										var signatureUpdatesKeys =
											Object.keys(signatureUpdates);

										//get the signatures
										condoDocsSignatures =
											signatureUpdates[
												signatureUpdatesKeys[
													signatureUpdatesKeys.length -
														1
												]
											]['signature_request'][
												'signatures'
											];
										aClient['condoDocsSignatures'] =
											condoDocsSignatures;

										var condoDocsStatus = '';

										//getting the status of the Condo Docs
										if (condoDocsSignatures) {
											var condoDocsSignaturesArray = [];
											var signatureKeys =
												Object.keys(
													condoDocsSignatures
												);

											signatureKeys.forEach(
												(signatureKey) => {
													var status_code =
														condoDocsSignatures[
															signatureKey
														]['status_code'];

													condoDocsSignaturesArray.push(
														status_code
													);
												}
											);

											if (
												condoDocsSignaturesArray.length ===
												1
											) {
												//no second purchaser

												console.log(
													'condoDocsSignaturesArray should be hereee'
												);

												//@TODO: Maybe there is a bug here. THe signatures dont include the admin and builder status right away.
												//check the status
												if (
													condoDocsSignaturesArray[0] ===
													'signed'
												) {
													condoDocsStatus =
														'Condo Document completed';
												} else {
													condoDocsStatus =
														'Waiting for Client to sign';
												}
											} else if (
												condoDocsSignaturesArray.length ==
												2
											) {
												//have second purchaser
												if (
													condoDocsSignaturesArray[0] ===
														'awaiting_signature' &&
													condoDocsSignaturesArray[1] ===
														'awaiting_signature'
												) {
													condoDocsStatus =
														'Waiting for Client to sign';
												} else if (
													condoDocsSignaturesArray[0] ===
														'signed' &&
													condoDocsSignaturesArray[1] ===
														'awaiting_signature'
												) {
													condoDocsStatus =
														'Clients signed. Waiting for Second Client to sign';
												} else if (
													condoDocsSignaturesArray[0] ===
														'signed' &&
													condoDocsSignaturesArray[1] ===
														'signed'
												) {
													condoDocsStatus =
														'Condo Document completed';
												}
											} else if (
												condoDocsSignaturesArray[
													condoDocsSignaturesArray.length -
														1
												] === 'signed'
											) {
												condoDocsStatus =
													'Condo Document completed';
											}
										}

										aClient['condoDocsStatus'] =
											condoDocsStatus;
									}
								}
							}
						);
					}

					aClient['keyValue'] = snapClientsKeys[i];
					aClient['salesAgentPointer'] = thisSalesAgentPointer;

					console.log("aClient['coBrokerId']", aClient['coBrokerId']);

					//if myClients coBrokerId === currentUserId then push
					if (aClient['coBrokerId'] == currentUserId) {
						currentClientList.push(aClient);
					}
				}
			}

			console.log('currentClientList', currentClientList);

			await pushToClient(
				currentClientList,
				(returned) => allVisibleClients.push(returned),
				(returned) => nonVisibleClients.push(returned)
			);

			console.log(
				'GetAllVisibleClients allVisibleClients 63',
				allVisibleClients
			);
			callback(allVisibleClients);
		});
}

export async function pushToClient(
	currentClientList,
	allVisibleClients,
	nonVisibleClients
) {
	for (const client of currentClientList) {
		console.log('currentClientList', currentClientList);
		if (client.showClient === true) {
			await GetClientExpandedInfo(client).then((result) => {
				client['expandedClientInfo'] = result;
			});

			allVisibleClients(client);
		} else {
			nonVisibleClients(client);
		}
	}
}

export async function GetAllVisibleClientsForSpecificClient() {
	//const { firebase } = useContext(FirebaseContext);

	var allVisibleClients = [];
	var nonVisibleClients = [];
	var currentClientList = [];

	var thisSalesAgentPointer;

	var salesAgentId;
	var currentUserId = firebase.auth().currentUser.uid;

	await getCoBrokersSalesAgent().then(
		(returned) => (salesAgentId = returned)
	);

	await firebase
		.database()
		.ref('kavtek_clients/' + PROJECT_CODE.projectCode + '/salesAgents')
		.orderByChild('createrID')
		.equalTo(salesAgentId)
		.limitToFirst(1)
		.once('value', (snapshot) => {
			var snapData = snapshot.val();

			//console.log("SnapData " +  JSON.stringify(snapData));

			var allKeys = Object.keys(snapData);

			//var keyToCall = snapData[allKeys[0]];

			thisSalesAgentPointer = allKeys[0];

			return thisSalesAgentPointer;
		});

	console.log('saveOrUpdateDocument key' + thisSalesAgentPointer);
	await firebase
		.database()
		.ref(
			'kavtek_clients/' +
				PROJECT_CODE.projectCode +
				'/salesAgents/' +
				thisSalesAgentPointer +
				'/myClients'
		)
		.once('value', (snapshot) => {
			//console.log(JSON.stringify(snapshot.val()));
			snapshot.forEach((clientData) => {
				var aClient = clientData.val();

				aClient['keyValue'] = clientData.key;
				aClient['salesAgentPointer'] = thisSalesAgentPointer;

				//console.log(" Client email " + aClient.clientEmail + " id " + aClient.id + " client key " + clientData.key);
				currentClientList.push(aClient);
			});
		});

	//for(const client of currentClientList)

	//currentClientList.forEach(async (client) => {

	for (const client of currentClientList) {
		console.log('currentClientList', currentClientList);
		if (client.showClient === true) {
			await GetClientExpandedInfo(client).then((result) => {
				client['expandedClientInfo'] = result;

				//console.log("Current Client List Add to client " + JSON.stringify(result));
			});

			console.log('Adding client to list');

			allVisibleClients.push(client);
		} else {
			nonVisibleClients.push(client);
		}
	}

	console.log('Visible Client RECEIVED', allVisibleClients);

	return allVisibleClients;
}

export async function GetSpecificClient(_clientEmail) {
	var allClients;
	await GetAllVisibleClientsForSpecificClient().then((returned) => {
		allClients = returned;
	});

	var thisClient;

	allClients.forEach((client) => {
		if (client.clientEmail === _clientEmail) {
			thisClient = client;
		}
	});

	return thisClient;
}

export async function GetClientExpandedInfo(client) {
	// data-appcode={client.appCode}
	// data-keyvalue={client.keyValue}
	// data-salesagentpointer={client.salesAgentPointer}
	// data-name={client.fullName}
	// data-docsent={client?.documentInformation?.documentStatus}
	// data-clientemail={client.clientEmail}

	var dataSet = {
		appcode: client.appCode,
		keyvalue: client.keyValue,
		salesagentpointer: client.salesAgentPointer,
		name: client.fullName,
		docsent: client?.documentInformation?.documentStatus,
		clientemail: client.clientEmail,
	};

	var currentUserId = firebase.auth().currentUser?.uid;

	var clientExpanded;

	await GetClientDocumentData(dataSet, currentUserId).then((result) => {
		clientExpanded = result;

		console.log('ReturnInfExpandedClients ' + JSON.stringify(result));
	});

	return clientExpanded;
}

//export default GetAllVisibleClients;
